import React, { ReactNode } from 'react';
import { CSSProperties } from 'styled-components';
import { StyledSection } from './section.styles';


export const Section = ({ children, style = {}, mode = 'light', className = '' }: { children: ReactNode, style?: CSSProperties, mode?: 'dark' | 'light', className?: string; }) => {
    return (
        <StyledSection style={style} className={`${mode} ${className}`}>
            {children}
        </StyledSection>
    );
};

